import { ref } from 'vue';

export default () => {
  const online = ref(navigator.onLine);
  const openSyncs = ref(0);
  const userDeniedSync = ref(false);

  return {
    state: { online, openSyncs, userDeniedSync },
    funcs: {}
  };
};
